var map = {
	"./development/assets/landing/images/bg.jpg": 73628,
	"./development/assets/landing/images/bg_mobile.jpg": 13502,
	"./development/assets/landing/images/logo.svg": 97929,
	"./development/assets/landing/images/logo_mobile.svg": 43264,
	"./swisstech/assets/landing/images/bg.jpg": 70894,
	"./swisstech/assets/landing/images/bg_mobile.jpg": 3114,
	"./swisstech/assets/landing/images/logo.svg": 54955,
	"./swisstech/assets/landing/images/logo_mobile.svg": 97545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41437;